export const SHOW_USER_DROP_DOWN = 'headerBar/SHOW_USER_DROP_DOWN'
export const UPDATE_SHOPPING_COUNT = 'headerBar/UPDATE_SHOPPING_COUNT'
export const UPDATE_MEMBER_DATA = 'login/UPDATE_MEMBER_DATA'

export const UPDATE_BUY_PRODUCTS = 'shoppingProgress/UPDATE_BUY_PRODUCTS'
export const UPDATE_BUY_REDEEMS = 'shoppingProgress/UPDATE_BUY_REDEEMS'
export const UPDATE_SHOPPING_DATA = 'shoppingProgress/UPDATE_SHOPPING_DATA'

export const UPDATE_BUY_SPECIALS = 'specials/UPDATE_BUY_SPECIALS'
